"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgVisa = function SvgVisa(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: 32,
    height: 21,
    fill: "none"
  }, props), {}, {
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      children: title
    }) : null, (0, _jsxRuntime.jsxs)("g", {
      clipPath: "url(#Visa_svg__clip0)",
      children: [(0, _jsxRuntime.jsx)("path", {
        d: "M30.4 0H1.6A1.6 1.6 0 000 1.6v17.056a1.6 1.6 0 001.6 1.6h28.8c.883 0 1.6-.726 1.6-1.6V1.6c0-.883-.727-1.6-1.6-1.6z",
        fill: "#0842A6"
      }), (0, _jsxRuntime.jsx)("path", {
        d: "M15.877 6.363l-1.62 7.55h-1.954l1.62-7.55h1.954zm8.219 4.88l1.03-2.838.59 2.838h-1.62zm2.18 2.67h1.806l-1.57-7.55h-1.67a.902.902 0 00-.834.55l-2.927 6.99h2.053l.402-1.129h2.504l.236 1.14zM21.18 11.45c.01-1.993-2.76-2.101-2.74-2.995.01-.275.265-.56.825-.628.285-.04 1.05-.069 1.924.334l.344-1.6a5.32 5.32 0 00-1.826-.335c-1.934 0-3.29 1.031-3.3 2.494-.01 1.09.973 1.69 1.71 2.052.755.373 1.01.61 1.01.943-.01.51-.608.727-1.168.736-.982.01-1.551-.265-2.003-.48l-.354 1.649c.452.206 1.297.393 2.17.402 2.063.01 3.398-1.001 3.408-2.572zm-8.091-5.086l-3.162 7.55H7.865L6.304 7.895c-.098-.373-.177-.51-.462-.657-.47-.266-1.247-.501-1.924-.648l.05-.217h3.328c.422 0 .805.285.903.766l.825 4.37 2.032-5.135h2.033v-.01z",
        fill: "#fff"
      })]
    }), (0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsx)("clipPath", {
        id: "Visa_svg__clip0",
        children: (0, _jsxRuntime.jsx)("path", {
          fill: "#fff",
          d: "M0 0h32v20.266H0z"
        })
      })
    })]
  }));
};

var _default = SvgVisa;
exports["default"] = _default;